import { render } from "./BattleList.vue?vue&type=template&id=8ac63f4e&scoped=true&ts=true"
import script from "./BattleList.vue?vue&type=script&lang=ts"
export * from "./BattleList.vue?vue&type=script&lang=ts"

import "./BattleList.vue?vue&type=style&index=0&id=8ac63f4e&lang=scss&scoped=true"
import "./BattleList.vue?vue&type=style&index=1&id=8ac63f4e&lang=scss"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac63f4e"]])

export default __exports__